module.exports = __webpack_public_path__ + "img/sort_icon.0fea53f8.svg";